module.exports = __webpack_public_path__ + "img/pickTwo.ce2c7515.png";